import { renderInertiaApp } from '../inertia'

renderInertiaApp()
